import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-knowledge-foundations }}\n{{outlet}}",{ moduleName: "embercom/templates/apps/app/articles/articles/list.hbs" })